export default __webpack_public_path__ + "static/media/advertising.a7876f4b.jpg";